import React, { useState, useRef, createRef } from 'react'
import "./clientlogin.css"
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../setup/AuthContext'
import appCheck from '../../../setup/Firebase';
import { db, auth, app, } from '../../../setup/Firebase'; // Import your Firebase instance

export default function ClientLogin() {

  
  const emailRef = useRef()
  const passwordRef = useRef()
  const { login } = useAuth()
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
   async function handleSubmit(e) {
      e.preventDefault();
      // const recaptchaValue = recaptchaRef.current.getValue();
      // this.props.handleSubmit(recaptchaValue);
      try {
          setError('')
          setLoading(true)
          await login(emailRef.current.value, passwordRef.current.value)
          navigate("/dashboard")
      }   catch(e) {
            console.log(e)
            setError('Login Credentials incorrect, failed to sign in')
            alert(error)
      }

      setLoading(false)
  }

  // function onChange(value) {
  //   console.log("Captcha value:", value);
  // }

  return (
    <div className='emas__clientlogin'>
      <div className='emas__clientlogin-container'>
        <h1>Client Login</h1>
        <a href='/client-signup'>Create a free account</a>
        <form onSubmit={handleSubmit}>
          <p>Email</p>
          <input ref={emailRef} type={"email"} placeholder="enter email" required />
          <p>Password</p>
          <input ref={passwordRef} type={"password"} placeholder="enter password" required />
          <div className='emas__clientlogin-container_captcha'>
          </div>
          <button disabled={loading} type="submit">{loading ? 'Logging in...' : 'Login'}</button>
        </form>
      </div>
    </div>
  )
}


